import { useAppSelector } from "../rtk/_config/hooks";

export function useAbTestVariant(): "A" | "B" {
  const user_id = useAppSelector((state) => state.tracker.user_id);

  const searchParams = new URLSearchParams(window.location.search);
  const forcedVariant = searchParams.get("variant");

  if (forcedVariant === "A" || forcedVariant === "B") {
    return forcedVariant;
  }

  if (!user_id) return "A";
  return user_id % 2 === 0 ? "A" : "B";
}